export const CounterPartys = {
    SET: "counterpartys.set",
    UPDATE: "counterpartys.update",
    ERROR: "counterpartys.error",
};
